import { render, staticRenderFns } from "./ICN004-01_add_point.vue?vue&type=template&id=a3c9ae40&"
import script from "./ICN004-01_add_point.vue?vue&type=script&lang=js&"
export * from "./ICN004-01_add_point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports